<template>
  <div>
    <div class='container'>
      <div class="row justify-content-center">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div
            class="signin-inner mt-3 mt-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
            <div class="text-center text-md-center mb-4 mt-md-0">
              <h1 class="mb-0 h3">{{companyname}}管理系統登入</h1>
            </div>
            <form action="#" class="mt-4" @submit.prevent='login()'>
              <div class="form-group">
                <div class="input-group" v-if='codeself'>
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <font-awesome-icon :icon="['far', 'building']" />
                    </span></div><input type="text" class="form-control" 
                    placeholder="公司統一編號" required="" v-model='input.uniform'>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <font-awesome-icon :icon="['far', 'user']" />
                    </span></div><input type="text" class="form-control"
                    placeholder="輸入您註冊的帳號" required="" v-model='input.account'>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <font-awesome-icon :icon="['fas', 'unlock-alt']" />
                    </span></div>
                    
                    <input class="form-control" placeholder="輸入您的密碼"
                      :type="passwordmethod"
                    required="" v-model='input.password'>
                  <div class="input-group-append"><span class="input-group-text"
                      @click='taggetpwd()' >
                    <font-awesome-icon
                      :icon="['far', (passwordmethod=='password'?'eye':'eye-slash')]" />
                    </span></div>
                </div>
                <div class="d-block d-sm-flex justify-content-between align-items-center mt-2">
                  <div><a href="./forgot-password.html" class="small text-right">忘記密碼</a>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <button type="submit" class="btn btn-block btn-primary">
                  進入管理平台
                </button>
              </div>
            </form>
            <!-- <div class="btn-wrapper my-4 text-center"><button
                class="btn mr-2 btn-icon-only btn-pill btn-twitter" type="button"><span
                  class="btn-inner-icon"><i class="fab fa-twitter"></i></span></button> <button
                class="btn mr-2 btn-icon-only btn-pill btn-facebook" type="button"><span
                  class="btn-inner-icon"><i class="fab fa-facebook-f"></i></span></button> <button
                class="btn mr-2 btn-icon-only btn-pill btn-google" type="button"><span
                  class="btn-inner-icon"><i class="fab fa-google"></i></span></button></div> -->
            <div class="d-block d-sm-flex justify-content-center align-items-center mt-4">
              <span class="font-weight-normal">想要自己的商店嗎？ <a href="./sign-up.html"
                  class="font-weight-bold">立即自己商店</a></span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ctrl from "@/js/login.js";
  export default ctrl

</script>
